import { CanUseWebp } from 'constants/canUseWebp';

const MaxPixelsPerImage = 500 * 500;

export function getImageUrl({
    imageUrl,
    width,
    height,
}: {
    imageUrl?: string;
    width: number;
    height?: number;
}): string {
    height = height || width;
    if (!imageUrl) {
        return '';
    }

    const separator = imageUrl.indexOf('?') === -1 ? '?' : '&';
    const requestedPixelCount = height * width;
    const compression = requestedPixelCount <= MaxPixelsPerImage ? 100 : 80;

    let url = `${imageUrl}${separator}width=${width}&height=${height}&compression=${compression}`;

    if (CanUseWebp) {
        url = `${url}&format=webp`;
    }

    return url;
}
